export class IExpertTraining {
    name: string;
    schoolOrEntity: string;
    yearOfCompletion: number;
}
